import { useEffect, useState } from "react";
import { getSocket } from "../config/socket";
import { useNavigate } from "react-router-dom";

const useDisconnectSocket = () => {
    const navigate = useNavigate();
    const [disconnect, setDisconnect] = useState(false);
    const socket = getSocket();

    useEffect(() => {
        if (socket) {
            socket.on('disconnect_reason', (reason) => {
                setDisconnect(true);
                localStorage.clear(); // Limpiar y vaciar el localStorage.
                navigate("/", { replace: true });
                console.log('EL SOCKET SE DESCONECTÓ ///////////////HOOK/////////////////', reason);
            });
        }
        return () => {
            if (socket) {
                socket.off('disconnect_reason');
            }
        };
    }, [socket, navigate]);

    return disconnect;
};

export default useDisconnectSocket;
